import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../store/store";
import LocationService from "../services/LocationService";
import {
  setDepartments,
  setMunicipalities,
} from "../store/slices/locations/locationSlice";

export const useLocation = () => {
  const dispatch: AppDispatch = useDispatch();

  const { departments, municipalities } = useSelector(
    (state: RootState) => state.location
  );

  // 🔹 Obtener todos los departamentos
  const fetchDepartments = async () => {
    try {
      const response = await LocationService.fetchDepartments();
      dispatch(setDepartments(response));
    } catch (error) {
      console.error("Error al cargar departamentos:", error);
    }
  };

  // 🔹 Obtener municipios usando el código oficial del departamento
  const fetchMunicipalitiesByDepartment = async (departmentCode: string) => {
    try {
      const response = await LocationService.fetchMunicipalitiesByDepartment(departmentCode);
      dispatch(setMunicipalities(response));
    } catch (error) {
      console.error("Error al cargar municipios:", error);
    }
  };

  return {
    departments,
    municipalities,
    fetchDepartments,
    fetchMunicipalitiesByDepartment,
  };
};
